export enum ReviewTitle {
  DESIGNRUSH = 'Designrush', 
  CLUTCH = 'Clutch', 
  TRUSTPILOT = 'Trustpilot', 
  GOODSFIRMS = 'Goodfirms',
  GOOGLE = 'Google',
  FRAMER = 'Framer',
}